import React from 'react';
import { useAssistantIntents } from '../../hooks/useLottoAssistantContext';
import UsageLimitCard from '../UsageLimitCard';
import BettingOptions from '../BettingOptions';
import LotteryList from '../LotteryList';
import QuickPickTickets from '../QuickPickTickets';
import LotteriesLastResults from '../LotteriesLastResults';
import LotteryDrawHistory from '../LotteryDrawHistory';

const BotMessageWidget = ({ component, message, messageId, onWidgetDataLoaded }) => {
  const {
    handleQuickPick,
    handleBrowseLotteries,
    handleOutcomeSelect,
    handleLotterySelect,
    stageLotteryList,
    stageLotteryId,
  } = useAssistantIntents();

  const props = component.props ?? {};

  switch (component.type) {
    case 'usage_limit_reached':
      return (
        <UsageLimitCard
          message={message}
          handleBrowseLotteries={() => handleBrowseLotteries({ withSuggestedOptions: true })}
          handleQuickPick={handleQuickPick}
          onWidgetDataLoaded={onWidgetDataLoaded}
        />
      );

    case 'betting_options':
      return (
        <BettingOptions
          intentArgs={props}
          message={message}
          onOutcomeSelect={handleOutcomeSelect}
          onLotteryViewed={stageLotteryId}
          onWidgetDataLoaded={onWidgetDataLoaded}
        />
      );

    case 'search_lotteries':
      return (
        <LotteryList
          intentArgs={props}
          message={message}
          onLotterySelect={handleLotterySelect}
          onOutcomeSelect={handleOutcomeSelect}
          onLotteriesLoaded={stageLotteryList}
          onWidgetDataLoaded={onWidgetDataLoaded}
        />
      );

    case 'quick_pick':
      return (
        <QuickPickTickets
          intentArgs={props}
          messageId={messageId}
          onWidgetDataLoaded={onWidgetDataLoaded}
        />
      );

    case 'lotteries_last_results':
      return (
        <LotteriesLastResults
          intentArgs={props}
          onWidgetDataLoaded={onWidgetDataLoaded}
        />
      );

    case 'lottery_draw_history':
      return (
        <LotteryDrawHistory
          intentArgs={props}
          onDataLoaded={onWidgetDataLoaded}
        />
      );

    default:
      return null;
  }
};

export default BotMessageWidget;
